import React, { useEffect, useState } from "react";
import { Sunrise, Sparkles } from "lucide-react";
import api from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { PANCHANG } from "@/constants/testIds";

const PanchangWidget = () => {
  const { lang } = useApp();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setData(null);
    api.get(`/panchang/today?lang=${lang}`)
      .then((r) => setData(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [lang]);

  return (
    <section
      data-testid={PANCHANG.widget}
      className="max-w-7xl mx-auto px-6 sm:px-10 my-16"
    >
      <div className="p-8 sm:p-10 border border-primary bg-primary text-primary-foreground relative overflow-hidden">
        <div className="grid md:grid-cols-12 gap-8 items-start relative">
          <div className="md:col-span-4">
            <div className="flex items-center gap-2 text-secondary">
              <Sunrise className="w-5 h-5" strokeWidth={1.5} />
              <p className="text-[10px] uppercase tracking-label">Today&apos;s Panchang</p>
            </div>
            <h2 className="font-serif text-4xl md:text-5xl mt-4 leading-tight">
              The sky&apos;s <em className="italic">rhythm</em>, today.
            </h2>
            <p className="text-sm mt-4 opacity-90 max-w-xs">
              Auspicious muhurats, tithi, nakshatra & rahu kaal for your day.
            </p>
          </div>
          <div className="md:col-span-8 relative">
            {loading && (
              <div className="flex items-center gap-2 text-sm opacity-80">
                <Sparkles className="w-4 h-4 animate-pulse" strokeWidth={1.5} />
                Consulting the celestial almanac…
              </div>
            )}
            {data && (
              <div
                data-testid={PANCHANG.content}
                className="whitespace-pre-wrap text-[15px] leading-relaxed border-l-2 border-secondary pl-6 font-normal"
              >
                {data.panchang}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PanchangWidget;
